<template>
  <custom-callout
    ref="detail-ref"
    :border-color-hex="statusSetColor"
    class-main="mt-3 rounded"
    :has-toggle="false"
  >
    <div class="row mr-md-0 align-items-center">
      <div class="col-12 col-md-2" :class="!isMobile ? 'text-center' : ''">
        <div class="d-flex flex-column color-black">
          <div
            :class="
              `mb-1 font-light badge badge-pill font-16 py-2 mt-2 w-90 mx-auto badge-${statusColorClass}`
            "
          >
            {{ data.statusName | empty }}
          </div>
        </div>
      </div>
      <div class="col-md-8" :class="!isMobile ? 'border-left' : ''">
        <div class="row">
          <div class="col-12 col-md-4 my-2">
            <span class="data-title d-block border-mobile">Año Académico:</span>
            <span class="font-16 color-black">
              {{ data.academicYearName | empty }}
            </span>
          </div>
          <div class="col-12 col-md-4 my-2">
            <span class="data-title d-block border-mobile">
              Tipo de Contrato:
            </span>
            <span class="font-16 color-black">
              {{ data.contractTypes }}
            </span>
          </div>
          <div class="col-12 col-md-4 my-2">
            <span class="data-title d-block">Fecha del Estatus:</span>
            <span class="font-16 color-black">
              {{ data.statusDate | date('DD/MM/YYYY') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-2 col-lg-2 mt-2 mt-lg-0">
        <div class="text-right">
          <action-button
            v-if="isPublished"
            id="historyBtn"
            class="withoutMargin"
            i="fas fa-history"
            type="button"
            variant="outline-success"
            @click="onHistoryButtonPress(data)"
          />
          <action-button
            id="editBtn"
            class="withoutMargin"
            :class="!isMobile ? 'ml-2' : 'mt-2'"
            i="fas fa-pencil"
            type="button"
            variant="success"
            @click="$emit('on-edit', data.contractTemplateId)"
          />
          <action-button
            id="printBtn"
            class="withoutMargin"
            :class="!isMobile ? 'ml-2' : 'mt-2'"
            i="fas fa-print"
            type="button"
            variant="success"
            @click="$emit('on-print', data.contractTemplateId)"
          />
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import store, { modulesName } from '@/store/index';
import contractTemplateStatus from '@/utils/constants/contractTemplateStatus';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    statusSetColor() {
      switch (this.data.statusId) {
        case contractTemplateStatus.Borrador:
          return '#B5C3BC';
        case contractTemplateStatus.Publicado:
          return '#A4E5B2';
        default:
          return null;
      }
    },
    statusColorClass() {
      switch (this.data.statusId) {
        case contractTemplateStatus.Borrador:
          return 'gray';
        case contractTemplateStatus.Publicado:
          return 'green-light';
        default:
          return null;
      }
    },
    isPublished() {
      return this.data.statusId === contractTemplateStatus.Publicado;
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
  },
  methods: {
    onHistoryButtonPress({ contractTemplateId }) {
      this.$router.push({
        name: 'contractTemplateHistory',
        params: { contractTemplateId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';
.badge-gray {
  background-color: map-get($colors, 'gray');
}

.badge-green-light {
  background-color: map-get($colors, 'green-light');
}

.withoutMargin ::v-deep {
  i {
    margin-right: 0rem !important;
  }
}
</style>
